import { ArchiveSearchOutlineIcon } from './ArchiveSearchOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 6705AD82-194D-411F-8822-EC3DA2379582
 * name archive-search-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-search-outline.svg
 * tags
 */
export const BoxSearchOutlineIcon = ArchiveSearchOutlineIcon;
export default BoxSearchOutlineIcon